// app/components/Plugins/Automations/nodes/implementations/StopNodeImpl.ts

import { BaseNode } from '../../core/BaseNode';
import { ExecutionContext } from '../../core/protocols';
import { AutomationNode, StopNodeData } from '../../types';

/**
 * Implementation of the Stop Node protocol
 * Responsible for stopping the execution of the automation flow
 */
export class StopNodeImpl extends BaseNode {
  constructor(node: AutomationNode) {
    super(node);
  }

  /**
   * Process the stop node
   * Stops the execution of the automation flow
   */
  async process(context: ExecutionContext): Promise<boolean> {
    // Log that the stop node was reached
    context.addLog('Stop node reached - stopping automation flow');
    
    // Set a flag in the context to indicate that execution should stop
    context.data.stopRequested = true;
    
    // Update any start nodes to cancel recurring execution
    if (context.data.recurringExecution) {
      context.addLog('Cancelling recurring execution');
    }
    
    // Return false to prevent further node processing
    return false;
  }

  /**
   * Validate the stop node configuration
   * Stop nodes don't have specific configuration requirements
   */
  validate() {
    // Use the base validation
    return super.validate();
  }

  /**
   * Get the input ports for this node
   * Stop node has one input
   */
  getInputs(): string[] {
    return ['in'];
  }

  /**
   * Get the output ports for this node
   * Stop node has no outputs as it stops the flow
   */
  getOutputs(): string[] {
    return [];
  }
}